<template>
    <div>
        <div class="header-return">
            <el-row>
                <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap"
                         :size="GCONFIG.styleElFormSize">
                    <el-form-item label="">
                        <el-button type="text" icon="el-icon-arrow-left" @click="returnHistory">返回</el-button>
                    </el-form-item>
                    <!--<el-form-item>-->
                        <!--<el-button type="primary" @click="getList">查询</el-button>-->
                        <!--<el-button type="success" @click="add()" class="header-btn">新建</el-button>-->
                    <!--</el-form-item>-->
                </el-form>
            </el-row>
        </div>

        <el-form :model="model" label-width="120px">
            <el-form-item label="举例说明">
                <el-alert title="企业微信服务人员注册" type="success" :closable="false">
                </el-alert>
            </el-form-item>
            <el-form-item label="企业id" prop="corpid">
                <el-input v-model="model.corpid" placeholder="企业id"></el-input>
                <span style="color: red">*在企业微信后台中查找</span>
            </el-form-item>
            <el-form-item label="用户userId" prop="userId">
                <el-input v-model="model.userId" placeholder="手机号"></el-input>
                <span style="color: red">*在企业微信后台中查找员工userId</span>
            </el-form-item>
            <el-form-item label="门店id" prop="store_id">
                <el-input v-model="model.store_id" placeholder="门店id"></el-input>
                <span style="color: red">*在微信支付商户后台查找门店id</span>
            </el-form-item>
            <el-form-item label="平台" >
                <el-select v-model="model.platformId" placeholder="平台"  >
                    <el-option v-for="item in platformData"
                               :key="item.platformId"
                               :label="item.platformName"
                               :value="item.platformId">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button @click="showDialog = false">取 消</el-button>
                <el-button type="primary" @click="save()" class="header-btn">
                    保存
                </el-button>
            </el-form-item>
        </el-form>


    </div>
</template>
<script>
    //导入 HTTP请求方法
    import {
        getPlatformList,
        setStaffSerivceApi
    } from '../../api/api';
    import {getRouterPageHash} from '@/api/http';
    export default {
        data() {
            return {
                showDialog: false,
                list: [],
                recordsTotal: 0,
                formInline: {
                    currentPage: 1,
                    pageSize: 20
                },
                model: {
                    userId: 'ShenQiDeYangYang',
                    corpid: 'wwc2a973e34f38f9e5',
                    store_id: '20757266',
                    platformId: 6
                },
                loading: true,
                platformData: []
            }
        },
        created() {

        },
        //挂载时候执行
        mounted(){
            this.getAllPlatformList();
        },
        methods: {
            getAllPlatformList() {
                getPlatformList().then((res) => {
                    this.platformData = res.data;
                })
            },
            save(){
                //保存应用
                if (this.model.userId == '') {
                    this.$message({
                        message: 'userId必填',
                        type: 'error'
                    });
                    return;
                }
                if (this.model.corpid == '') {
                    this.$message({
                        message: '企业id必填',
                        type: 'error'
                    });
                    return;
                }
                if (this.model.store_id == '') {
                    this.$message({
                        message: '门店id必须输入',
                        type: 'error'
                    });
                    return;
                }
                this.loading = true;
                setStaffSerivceApi(this.model).then((res) => {
                    this.loading = false;
                    console.log(res);
                    if (res.data.success) {
                        this.$message({
                            showClose: true,
                            message: '成功',
                            type: 'success'
                        });
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                    this.showDialog = false;
                });
            },
            formatDate(datetime) {
                if (datetime == null) {
                    return '';
                } else {
                    var date = new Date(datetime);
                    var year = date.getFullYear(),
                        month = ("0" + (date.getMonth() + 1)).slice(-2),
                        sdate = ("0" + date.getDate()).slice(-2),
                        hour = ("0" + date.getHours()).slice(-2),
                        minute = ("0" + date.getMinutes()).slice(-2),
                        second = ("0" + date.getSeconds()).slice(-2);
                    // 拼接
                    var result = year + "-" + month + "-" + sdate + " " + hour + ":" + minute + ":" + second;
                    // 返回
                    return result;
                }
            },
            returnHistory(){
                window.history.back()
            }
        }
    }
</script>
<style>
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }

    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }
</style>


// WEBPACK FOOTER //
// src/views/wechat/staffConfig.vue